import { render, staticRenderFns } from "./FieldArea.vue?vue&type=template&id=4acad6e5"
import script from "./FieldArea.vue?vue&type=script&lang=js"
export * from "./FieldArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports